import { call, put } from "redux-saga/effects";
import _ from "lodash";
import endpoint from "./endpoint";

const currencyFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export const getDashboard = (key) => {
  let dashboard = localStorage.getItem("dashboard");
  if (dashboard) {
    return JSON.parse(dashboard)?.[key];
  }
  return "-";
};

export function ActionTypesFactory(prefix, type) {
  let p = _.upperCase(prefix) + "/" + _.upperCase(type);
  return {
    REQUEST: p + "_REQUEST",
    INPROGRESS: p + "_INPROGRESS",
    SUCCESS: p + "_SUCCESS",
    FAILED: p + "_FAILED",
    CHANGED: p + "_CHANGED",
    RESET: p + "_RESET",
    custom: (name) => {
      return `${p}_${name}`;
    },
  };
};

export function sagaFunctions(action_type, method, api, data, headers) {
  return function* () {
    let res = null;
    try {
      if (method === "post" || method === "put") {
        if (localStorage.getItem("token"))
          data.authentication_token = localStorage.getItem("token")

        res = yield call(endpoint[method], api, data, {
          headers,
        });
      } else {
        let filters = data?.filters;
        if (filters) {
          delete data.filters;
        }
        res = yield call(endpoint[method], api, {
          headers,
          params: data ? data : {},
          body: filters,
        });
      }

      if (res.status < 400) {
        yield put({
          type: action_type.SUCCESS,
          payload: res.data,
        });
      } else {

        yield put({
          type: action_type.FAILED,
          payload: res.data,
        });
      }
    } catch (err) {

      yield put({
        type: action_type.FAILED,
        payload: err?.response?.data,
      });
    }
  };
};

export const LOGOUT = "LOG_OUT";
export const LOGOUT_MAINTAIN = "LOG_OUT__MAINTAIN";
export const MAINTAINANCE = "MAINTAINANCE";

export function ReducerFunctions(ActionType, initialState) {
  return function (state = initialState, action) {
    let data = Array.isArray(action?.payload)
      ? [...action?.payload]
      : typeof action?.payload === "string"
        ? action?.payload
        : { ...action?.payload };
    switch (action?.type) {
      case ActionType.REQUEST:
        return {
          ...state,
          loading: true,
        };
      case ActionType.SUCCESS: {
        return {
          ...state,
          data,
          loading: false,
          success: true,
        };
      }
      case ActionType.FAILED:
        return {
          ...state,
          data,
          loading: false,
          success: false,
        };
      case ActionType.RESET:
        return {
          loading: false,
        };

      case LOGOUT:
        return {
          logout: action.payload
        };

      default:
        return state;
    }
  };
};
//super admin access
export const hasAccess = (module) => {
  const permissions = localStorage.getItem("permissions")
  return permissions?.includes(module) || !permissions
}
// customer access
export const customerHasAccess = (module) => {
  if (!module) return true; // Always allow Dashboard, My Profile, etc.

  const userType = localStorage.getItem("user_type");

  // For non-delegate users → always show
  if (userType !== "delegate_user") {
    return true;
  }

  // For delegate users → check permissions
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
    const modulePerms = permissions[module];
    return modulePerms?.view === true || modulePerms?.full_access === true;
  } catch (err) {
    console.error("Invalid permissions format:", err);
    return false;
  }
};
// ✅ Read-only access (view = true, full_access = false)
export const hasOnlyView = (module) => {
  const raw = localStorage.getItem("permissions");
  const userType = localStorage.getItem("user_type");

  let permissions = [];
  try {
    permissions = raw ? JSON.parse(raw) : [];
  } catch {
    // Fallback for old comma-separated strings
    permissions = raw ? raw.split(',') : [];
  }
  return (
    userType === "delegate_user" &&
    permissions?.[module]?.view === true &&
    permissions?.[module]?.full_access === false
  );
};

// Returns "none" | "view_only" | "full_access"
export const getAccessLevel = (module) => {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  const userType = localStorage.getItem("user_type");

  if (userType !== "delegate_user") return "full_access";

  const view = permissions?.[module]?.view;
  const full = permissions?.[module]?.full_access;

  if (full) return "full_access";       // regardless of view
  if (view && !full) return "view_only";
  return "none";
};



export const getAddress = (addr) => {
  return addr?.name +
    ", " + (addr?.address1 ? `
    ${addr?.address1}, ` : "") +
    (addr?.address2 ? `
  ${addr?.address2}, ` : "") +
    (addr?.city ? `${addr?.city}, ` : "") + (addr?.state ? `${addr?.state}, ` : "") + addr?.zip
}

export const getAddressVal = (addr) => {
  return (addr?.address1 ? `
    ${addr?.address1} ` : "") +
    (addr?.address2 ? `
  ${addr?.address2} ` : "") +
    (addr?.city ? `${addr?.city} ` : "") + (addr?.state ? `${addr?.state}` : "")
}

export const amountFormat = (amount) => {
  return Number.isNaN(amount) ? "-" : currencyFormat.format(parseFloat(amount));
};

export const downloadPDF = (pdf, name) => {
  const linkSource = `data: application / pdf; base64, ${pdf} `;
  const downloadLink = document.createElement("a");
  const fileName = name + ".pdf";
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.style.display = "none"
  downloadLink.click();
  downloadLink.remove();
}

export const isTokenPresent = () => {
  const token = localStorage.getItem('token'); // You can replace this with your actual token storage mechanism
  return !!token; // Returns true if token is present, false otherwise
};



const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const generateString = (length) => {
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result.trim();
}

// Open IndexedDB
function openDB() {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open('Customers', 1);
    // request.onupgradeneeded = event => {
    //   const db = event.target.result;
    //   // You can add more properties by adding indexes:
    //   // store.createIndex('propertyName', 'propertyName', { unique: false });
    //   const objectStore = db.createObjectStore('customers', { keyPath: 'id' });

    //   // Define the structure of the data to be stored
    //   objectStore.createIndex('name', 'name', { unique: false });
    //   objectStore.createIndex('email', 'email', { unique: false });
    // };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Getter method to get data from IndexedDB
export const getData = async () => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction('customers', 'readonly');
    const store = transaction.objectStore('customers');
    const request = store.getAll();

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

// Setter method to store data in IndexedDB
export const setData = async (data) => {
  const request = await openDB();
  return new Promise((resolve, reject) => {
    request.then(function (event) {
      const db = event;

      // Access the database and object store
      const transaction = db.transaction('customers', 'readwrite');
      const objectStore = transaction.objectStore('customers');

      // Add the data to the object store
      data.forEach(function (customer) {
        objectStore.add(customer);
      });

      resolve('Data added to IndexedDB');
    }).catch(function (event) {
      reject('Error opening database:', event.target.error);
    });
  });
}

export const logoutAndRemoveCustomersData = () => {
  const request = indexedDB.open();

  request.then(function (event) {
    const db = event;
    const versionRequest = db.setVersion(1);
    versionRequest.onsuccess = function () {
      if (db.objectStoreNames.contains('customers')) {
        db.deleteObjectStore('customers');
      }
    };
  }).catch(function (event) {
    console.error('Error opening database:', event.target.error);
  });
}

let idleTimeout;
export const startIdleTimer = (onTimeout) => {
  const resetTimer = () => {
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(onTimeout, 60 * 60 * 1000); // 1 hour
  };

  window.onload = resetTimer;
  document.onmousemove = resetTimer;
  document.onkeypress = resetTimer;
  document.onclick = resetTimer;
  document.onscroll = resetTimer;
};